const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-generic-components/shared/components/components");